export const layoutUtils = {
  getSectionNamesBySorted: (sectionsConfig: any) =>
    Object.keys(sectionsConfig)
      .filter((el) => sectionsConfig[el].orderNumber)
      .sort(
        (a, b) => sectionsConfig[a].orderNumber - sectionsConfig[b].orderNumber
      ),
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppDefaultLayout/utils/utils.ts